module.exports = __webpack_public_path__ + "static/media/sort-shapes-up-alt.cd0ef071.svg";